import { IPlacingTerms } from '../../../browser/addform/types';

// Актуально для старой ФВУ
export const getSelected = (placingTermsApi: IPlacingTerms) => {
  const { selected } = placingTermsApi;

  if (selected && selected.option && Array.isArray(selected.additionals)) {
    return selected;
  }

  return null;
};
